// src/pages/Public/Confidentialite.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import {
  FiShield,
  FiLock,
  FiUser,
  FiMail,
  FiDatabase,
  FiEye,
  FiTrash2,
} from "react-icons/fi";

const Confidentialite = () => {
  const sections = [
    {
      icon: FiShield,
      title: "Notre engagement",
      content:
        "Chez CAC - Chine Afrique Cargo, nous accordons une importance capitale à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.",
    },
    {
      icon: FiDatabase,
      title: "Données collectées",
      content:
        "Nous collectons uniquement les données nécessaires à nos services :\n• Nom, prénom\n• Adresse email\n• Numéro de téléphone\n• Adresse postale\n• Informations de paiement (via nos partenaires sécurisés)\n• Historique des colis et commandes",
    },
    {
      icon: FiLock,
      title: "Utilisation des données",
      content:
        "Vos données sont utilisées pour :\n• Gérer vos commandes et livraisons\n• Vous informer sur l'état de vos colis\n• Vous envoyer nos offres et actualités (avec votre consentement)\n• Améliorer nos services\n• Répondre à vos demandes",
    },
    {
      icon: FiEye,
      title: "Partage des données",
      content:
        "Nous ne partageons vos données qu'avec :\n• Nos partenaires de transport et logistique\n• Les autorités douanières (obligation légale)\n• Nos processeurs de paiement sécurisés\nNous ne vendons jamais vos données à des tiers.",
    },
    {
      icon: FiUser,
      title: "Vos droits",
      content:
        "Conformément au RGPD, vous disposez des droits suivants :\n• Droit d'accès à vos données\n• Droit de rectification\n• Droit à l'effacement (droit à l'oubli)\n• Droit à la portabilité\n• Droit d'opposition\n• Droit de limitation du traitement",
    },
    {
      icon: FiTrash2,
      title: "Conservation des données",
      content:
        "Vos données sont conservées :\n• Pendant la durée de notre relation commerciale\n• Jusqu'à 5 ans après la dernière interaction (obligation légale)\n• Vous pouvez demander leur suppression à tout moment",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Politique de Confidentialité - CAC</title>
        <meta
          name="description"
          content="Découvrez comment CAC - Chine Afrique Cargo protège vos données personnelles. Politique de confidentialité conforme au RGPD."
        />
        <link
          rel="canonical"
          href={window.location.origin + "/confidentialite"}
        />
      </Helmet>

      <div className="privacy-page">
        <div className="privacy-hero">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h1 className="privacy-hero-title">
                  🔒 Politique de Confidentialité
                </h1>
                <p className="privacy-hero-subtitle">
                  Nous protégeons vos données personnelles avec la plus grande
                  rigueur
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="privacy-container py-5">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="privacy-intro">
                <p className="text-muted text-center mb-4">
                  Dernière mise à jour :{" "}
                  {new Date().toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
              </div>

              <div className="privacy-grid">
                {sections.map((section, index) => (
                  <div key={index} className="privacy-card">
                    <div className="privacy-card-icon">
                      <section.icon size={32} />
                    </div>
                    <h3 className="privacy-card-title">{section.title}</h3>
                    <div className="privacy-card-content">
                      {section.content.split("\n").map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="privacy-contact">
                <h4>📧 Contact</h4>
                <p className="text-muted">
                  Pour toute question concernant cette politique, contactez-nous
                  :
                </p>
                <div className="d-flex gap-3 justify-content-center flex-wrap">
                  <a
                    href="mailto:privacy@chineafriquecargo.com"
                    className="btn btn-outline-danger px-4 py-2 rounded-pill"
                  >
                    privacy@chineafriquecargo.com
                  </a>
                  <a
                    href="/contact"
                    className="btn btn-danger px-4 py-2 rounded-pill"
                  >
                    📞 Nous contacter
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <style>{`
                    .privacy-page {
                        background: #f8f9fa;
                        min-height: 100vh;
                    }
                    
                    .privacy-hero {
                        background: linear-gradient(135deg, #0a0a2a 0%, #1a1a4e 50%, #0a0a2a 100%);
                        padding: 80px 0 60px;
                    }
                    
                    .privacy-hero-title {
                        font-size: 48px;
                        font-weight: 800;
                        color: white;
                        margin-bottom: 16px;
                    }
                    
                    .privacy-hero-subtitle {
                        font-size: 18px;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    
                    .privacy-grid {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 24px;
                    }
                    
                    .privacy-card {
                        background: white;
                        border-radius: 16px;
                        padding: 30px;
                        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
                        transition: all 0.3s ease;
                    }
                    
                    .privacy-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                    }
                    
                    .privacy-card-icon {
                        width: 60px;
                        height: 60px;
                        border-radius: 12px;
                        background: rgba(198, 40, 40, 0.1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #C62828;
                        margin-bottom: 16px;
                    }
                    
                    .privacy-card-title {
                        font-size: 20px;
                        font-weight: 700;
                        margin-bottom: 12px;
                        color: #1a1a3e;
                    }
                    
                    .privacy-card-content p {
                        color: #555;
                        line-height: 1.6;
                        margin-bottom: 8px;
                    }
                    
                    .privacy-card-content p:last-child {
                        margin-bottom: 0;
                    }
                    
                    .privacy-contact {
                        text-align: center;
                        background: white;
                        border-radius: 16px;
                        padding: 40px;
                        margin-top: 30px;
                        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
                    }
                    
                    @media (max-width: 992px) {
                        .privacy-hero-title {
                            font-size: 36px;
                        }
                        
                        .privacy-grid {
                            grid-template-columns: 1fr;
                        }
                    }
                    
                    @media (max-width: 768px) {
                        .privacy-hero-title {
                            font-size: 28px;
                        }
                    }
                `}</style>
      </div>
    </>
  );
};

export default Confidentialite;
